import { ApiResource } from '@/core/models/ApiResource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CreatePerformanceCounter, PerformanceCounter } from './performance-counter.interface';
import { PerformanceCounterService } from './performance-counter.service';
const service = new PerformanceCounterService();

export interface PerformanceCounterState {
   performanceCountersOverview?: ApiResource<Array<PerformanceCounter>>;
}

const PerformanceCounterStore: Module<PerformanceCounterState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_PERFORMANCE_COUNTERS_OVERVIEW(state, overview: ApiResource<Array<PerformanceCounter>>) {
         state.performanceCountersOverview = overview;
      },
   },
   actions: {
      async getPerformanceCounters(context, payload: { employeeId: number; query?: LocationQuery }) {
         const response = await service.getPerformanceCounters(payload.employeeId, payload.query);
         context.commit('SET_PERFORMANCE_COUNTERS_OVERVIEW', response);
         return response;
      },
      async createPerformanceCounter(context, payload: { employeeId: number; performanceCounter: CreatePerformanceCounter }) {
         const response = await service.postPerformanceCounter(payload.employeeId, payload.performanceCounter);
         return response;
      },
   },
};

export default PerformanceCounterStore;
